import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d59qhcsf78kfudd4jsr0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nome: '', email: '', mensagem: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name === 'mensagem' && value.length > 500) return;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <section id="contato" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left - Info */}
          <div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Fale Conosco
            </h2>
            <p className="text-xl text-gray-600 mb-12 leading-relaxed">
              Tem alguma dúvida sobre o desafio? Entre em contato conosco e nossa equipe terá prazer em ajudar você.
            </p>

            <div className="space-y-8">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-100 to-teal-200 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">E-mail</h3>
                  <p className="text-gray-600">ceitil.rui@gmail.com</p>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-gradient-to-br from-lime-100 to-lime-200 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-2xl text-lime-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">WhatsApp</h3>
                  <p className="text-gray-600">917532506</p>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-gradient-to-br from-orange-100 to-orange-200 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Horário de Atendimento</h3>
                  <p className="text-gray-600">Segunda a Sexta: 9h às 18h</p>
                  <p className="text-gray-600">Sábado: 9h às 13h</p>
                </div>
              </div>
            </div>

            <div className="mt-12 flex gap-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-gray-100 hover:bg-teal-500 rounded-xl flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-instagram-line text-xl text-gray-700 group-hover:text-white"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-gray-100 hover:bg-teal-500 rounded-xl flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-facebook-fill text-xl text-gray-700 group-hover:text-white"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-gray-100 hover:bg-teal-500 rounded-xl flex items-center justify-center transition-colors cursor-pointer group">
                <i className="ri-youtube-fill text-xl text-gray-700 group-hover:text-white"></i>
              </a>
            </div>
          </div>

          {/* Right - Form */}
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl shadow-2xl p-10">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">
              Envie sua Mensagem
            </h3>

            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="contact-nome" className="block text-sm font-semibold text-gray-700 mb-2">
                  Nome *
                </label>
                <input
                  type="text"
                  id="contact-nome"
                  name="nome"
                  required
                  value={formData.nome}
                  onChange={handleChange}
                  className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-teal-500 focus:outline-none transition-colors text-base"
                  placeholder="Seu nome"
                />
              </div>

              <div>
                <label htmlFor="contact-email" className="block text-sm font-semibold text-gray-700 mb-2">
                  E-mail *
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-teal-500 focus:outline-none transition-colors text-base"
                  placeholder="seu@email.com"
                />
              </div>

              <div>
                <label htmlFor="mensagem" className="block text-sm font-semibold text-gray-700 mb-2">
                  Mensagem * ({formData.mensagem.length}/500)
                </label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  required
                  rows={5}
                  maxLength={500}
                  value={formData.mensagem}
                  onChange={handleChange}
                  className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-teal-500 focus:outline-none transition-colors resize-none text-base"
                  placeholder="Escreva sua mensagem aqui..."
                />
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border-2 border-green-500 text-green-800 px-6 py-4 rounded-xl">
                  <div className="flex items-center gap-3">
                    <i className="ri-checkbox-circle-fill text-2xl"></i>
                    <span className="font-semibold">Mensagem enviada com sucesso!</span>
                  </div>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border-2 border-red-500 text-red-800 px-6 py-4 rounded-xl">
                  <div className="flex items-center gap-3">
                    <i className="ri-error-warning-fill text-2xl"></i>
                    <span className="font-semibold">Erro ao enviar. Tente novamente.</span>
                  </div>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-bold text-lg px-8 py-5 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center gap-3">
                    <i className="ri-loader-4-line animate-spin text-xl"></i>
                    Enviando...
                  </span>
                ) : (
                  <span className="flex items-center justify-center gap-3">
                    <i className="ri-send-plane-fill text-xl"></i>
                    ENVIAR MENSAGEM
                  </span>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
